<h1 class="page-title">Checkout and Pay</h1>
<app-product-list></app-product-list>
<form
    *ngIf="!noMoneyDue()"
    [formGroup]="checkoutForm"
    (ngSubmit)="onSubmit(checkoutForm.value)"
>
    <!-- <section>
    <h3>Select payment method</h3>
    <div class="form-row" style="width:100%;">
      <ul class="field-list field-list__item">
        <li class="field field--inline field-list__item field-list__item--inline">
					<input class="input input--radio" id="paymentType" value="CC" name="paymentType" type="radio" (change)="changePaymentType($event.target.value)" />
					<label for="paymentType" class="label label--inline">Credit Card</label>
				</li>
        <li class="field field--inline field-list__item field-list__item--inline">
					<input class="input input--radio" id="paymentType" value="ACH" name="paymentType" type="radio" (change)="changePaymentType($event.target.value)"/>
					<label for="paymentType" class="label label--inline">Check (enter your bank routing number and checking account number for payment)</label>
				</li>
      </ul>
    </div>
    <div *ngIf="formErrors.paymentType" class="error-message field__error-message">{{ formErrors.paymentType }}</div>
  </section> -->
    <div *ngIf="profile && showShipping">
        <h4>Shipping</h4>
        <strong>
            Verify that this is the address you want these products shipped to.
        </strong>
        <p>
            Click
            <a routerLink="/practitioner/profile/edit">here</a>
            to update the
    shipping address. After updating, return to complete the purchase by
    clicking on the shopping cart icon in the upper right-hand corner.
        </p>
        <span>{{ profile?.line1 }}</span>
        <span *ngIf="profile?.line2 && profile.line2 !== ''">
            <br>
            {{ profile?.line2 }}
        </span>
        <span>
            <br>
            {{ profile?.city }} {{ profile?.stateProvince }} {{ profile?.zip }}
            <br>
        </span>
    </div>
    <fieldset>
        <div *ngIf="paymentType == 'CC'">
            <legend>Credit Card Payment</legend>
            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="nameOnCard"
                        class="label"
                    >
                        Name on Card
                    </label>
                    <input
                        class="input input--large"
                        [class.input--invalid]="formErrors.nameOnCard"
                        id="nameOnCard"
                        formControlName="nameOnCard"
                        maxlength="35"
                        requiredIf="paymentType"
                        requiredIfValue="CC"
                    >
                    <div
                        *ngIf="formErrors.nameOnCard"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.nameOnCard }}
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="field form-row__item form-row__item--medium">
                    <div class="field__label-input-wrap">
                        <label
                            for="cardNumber"
                            class="label"
                        >
                            Card Number
                        </label>
                        <div
                            class="credit-card-number-input-wrap"
                            [class.credit-card-number-input-wrap--populated]="ccType"
                            [class.credit-card-number-input-wrap--amex]="
                ccType === cardTypes.Amex
              "
                            [class.credit-card-number-input-wrap--discover]="
                ccType === cardTypes.Discover
              "
                            [class.credit-card-number-input-wrap--mastercard]="
                ccType === cardTypes.MasterCard
              "
                            [class.credit-card-number-input-wrap--visa]="
                ccType === cardTypes.Visa
              "
                        >
                            <input
                                class="input input--medium"
                                [class.input--invalid]="formErrors.cardNumber"
                                formControlName="cardNumber"
                                id="cardNumber"
                                mask="0000 0000 0000 0000"
                                [dropSpecialCharacters]="true"
                                requiredIf="paymentType"
                                requiredIfValue="CC"
                            >
                            <div
                                *ngIf="formErrors.cardNumber"
                                class="error-message field__error-message"
                            >
                                {{ formErrors.cardNumber }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="expirationDate"
                            class="label"
                        >
                            Exp. Date
                        </label>
                        <input
                            class="input input--small"
                            [class.input--invalid]="formErrors.expirationDate"
                            formControlName="expirationDate"
                            id="expirationDate"
                            placeholder="MM/YY"
                            [dropSpecialCharacters]="true"
                            placeholder="MM/YY"
                            mask="00/00"
                            requiredIf="paymentType"
                            requiredIfValue="CC"
                        >
                        <div
                            *ngIf="formErrors.expirationDate"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.expirationDate }}
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="ccv"
                            class="label"
                        >
                            CCV
                        </label>
                        <input
                            class="input input--small"
                            [class.input--invalid]="formErrors.ccv"
                            formControlName="ccv"
                            id="ccv"
                            pattern="[0-9]{3,4}"
                            placeholder="123"
                            [dropSpecialCharacters]="true"
                            requiredIf="paymentType"
                            requiredIfValue="CC"
                        >
                        <div
                            *ngIf="formErrors.ccv"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.ccv }}
                        </div>
                    </div>
                </div>
            </div>
            <h4>Billing Address</h4>
            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="country"
                        class="label"
                    >
                        Country
                    </label>
                    <select
                        class="input input--select-menu input--large"
                        [class.input--invalid]="formErrors.countryId"
                        id="country"
                        formControlName="countryId"
                        requiredIf="paymentType"
                        requiredIfValue="CC"
                    >
                        <option value>Select One</option>
                        <option
                            *ngFor="let c of countries"
                            [value]="c.id"
                        >
                            {{ c.description }}
                        </option>
                    </select>
                    <div
                        *ngIf="formErrors.countryId"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.countryId }}
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="address"
                        class="label"
                    >
                        Address
                    </label>
                    <input
                        class="input input--large"
                        [class.input--invalid]="formErrors.address"
                        id="address"
                        formControlName="address"
                        maxlength="35"
                        requiredIf="paymentType"
                        requiredIfValue="CC"
                    >
                    <div
                        *ngIf="formErrors.address"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.address }}
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="city"
                            class="label"
                        >
                            City
                        </label>
                        <input
                            class="input"
                            [class.input--invalid]="formErrors.city"
                            id="city"
                            formControlName="city"
                            maxlength="35"
                            requiredIf="paymentType"
                            requiredIfValue="CC"
                        >
                        <div
                            *ngIf="formErrors.city"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.city }}
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="state"
                            class="label"
                        >
                            State&#x2F;Province
                        </label>
                        <input
                            class="input"
                            [class.input--invalid]="formErrors.state"
                            id="state"
                            formControlName="state"
                            maxlength="10"
                            requiredIf="isDomesticAndCreditCard()"
                            requiredIfValue="true"
                        >
                        <div
                            *ngIf="formErrors.state"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.state }}
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="zip"
                            class="label"
                        >
                            Zip&#x2F;Postal Code
                        </label>
                        <input
                            class="input"
                            [class.input--invalid]="formErrors.zip"
                            id="zip"
                            formControlName="zip"
                            maxlength="10"
                            requiredIf="paymentType"
                            requiredIfValue="CC"
                        >
                        <div
                            *ngIf="formErrors.zip"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.zip }}
                        </div>
                    </div>
                </div>
            </div>
            <p>
                By clicking 'Authorize Payment' below, I agree to pay
        {{ purchase.total | currency : "USD" : true }} according to the
        cardholder agreement.
            </p>
        </div>

        <div *ngIf="paymentType == 'ACH'">
            <legend>E-Check Payment</legend>

            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="credential"
                        class="label"
                    >
                        Account Type
                    </label>
                    <select
                        class="input input--select-menu"
                        id="accountType"
                        formControlName="accountType"
                        name="accountType"
                    >
                        <option value="checking">Checking</option>
                        <option value="savings">Savings</option>
                    </select>
                </div>
            </div>

            <img
                src="/assets/images/check-sample.png"
                style="width: 70%"
                alt="Sample image of a check"
            >

            <div class="field">
                <div class="field__label-input-wrap">
                    <label
                        for="nameOnAccount"
                        class="label"
                    >
                        Name on account
                    </label>
                    <input
                        class="input input--large"
                        [class.input--invalid]="formErrors.nameOnCard"
                        id="nameOnAccount"
                        formControlName="nameOnAccount"
                        maxlength="22"
                        requiredIf="paymentType"
                        requiredIfValue="ACH"
                    >
                    <div
                        *ngIf="formErrors.nameOnAccount"
                        class="error-message field__error-message"
                    >
                        {{ formErrors.nameOnAccount }}
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="routingNumber"
                            class="label"
                        >
                            Routing Number
                        </label>
                        <input
                            class="input input--medium"
                            [class.input--invalid]="formErrors.routingNumber"
                            id="routingNumber"
                            formControlName="routingNumber"
                            maxlength="9"
                            requiredIf="paymentType"
                            requiredIfValue="ACH"
                        >
                        <div
                            *ngIf="formErrors.routingNumber"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.routingNumber }}
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="routingNumberConfirm"
                            class="label"
                        >
                            Confirm Routing Number
                        </label>
                        <input
                            class="input input--medium"
                            [class.input--invalid]="formErrors.routingNumberConfirm"
                            id="routingNumberConfirm"
                            formControlName="routingNumberConfirm"
                            maxlength="9"
                            requiredIf="paymentType"
                            requiredIfValue="ACH"
                        >
                        <div
                            *ngIf="formErrors.routingNumberConfirm"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.routingNumberConfirm }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="accountNumber"
                            class="label"
                        >
                            Account Number
                        </label>
                        <input
                            class="input input--large"
                            [class.input--invalid]="formErrors.accountNumber"
                            id="accountNumber"
                            formControlName="accountNumber"
                            maxlength="17"
                            requiredIf="paymentType"
                            requiredIfValue="ACH"
                        >
                        <div
                            *ngIf="formErrors.accountNumber"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.accountNumber }}
                        </div>
                    </div>
                </div>
                <div class="field form-row__item">
                    <div class="field__label-input-wrap">
                        <label
                            for="accountNumberConfirm"
                            class="label"
                        >
                            Confirm Account Number
                        </label>
                        <input
                            class="input input--large"
                            [class.input--invalid]="formErrors.accountNumberConfirm"
                            id="accountNumberConfirm"
                            formControlName="accountNumberConfirm"
                            maxlength="17"
                            requiredIf="paymentType"
                            requiredIfValue="ACH"
                        >
                        <div
                            *ngIf="formErrors.accountNumberConfirm"
                            class="error-message field__error-message"
                        >
                            {{ formErrors.accountNumberConfirm }}
                        </div>
                    </div>
                </div>
            </div>
            <p>
                By clicking 'Authorize Payment' below, I authorize The National Board
        for Respiratory Care to charge my {{ accountType }} account on
        {{ currentDate | amDateFormat : "L" }} for the amount of
        {{ purchase.total | currency : "USD" : true }} for the products/services
        listed above.
            </p>
        </div>
        <div
            [hidden]="!serverMessage"
            id="serverMessage"
            class="error-message field__error-message"
        >
            {{ serverMessage }}
        </div>
        <div class="form-actions">
            <input
                [disabled]="isInvalidPayment()"
                class="button form-actions__item"
                type="submit"
                value="Authorize Payment"
            >
            <button
                (click)="onCancel($event)"
                class="button button--secondary form-actions__item"
                type="button"
            >
                Cancel
            </button>
        </div>
    </fieldset>
</form>
<div *ngIf="noMoneyDue()">
    <p>Click Submit to complete this order.</p>
    <div
        [hidden]="!serverMessage"
        id="serverMessage"
        class="error-message field__error-message"
    >
        {{ serverMessage }}
    </div>
    <div class="form-actions">
        <button
            (click)="noMoneyDueSubmit()"
            class="button form-actions__item"
            type="button"
            value="Submit"
        >
            Submit
        </button>
        <button
            (click)="onCancel($event)"
            class="button button--secondary form-actions__item"
            type="button"
        >
            Cancel
        </button>
    </div>
</div>
